import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import { loadTerms, loadingTermsSelector, termsSelector } from '@src/stores/app';
import Loading from '@src/components/ui2/Loading';
import { DocComponent } from '@src/features/terms/components/TermsModal';

type TermsProps = {
  type: 'terms_of_use' | 'privacy_policy';
};

const Terms = (props: TermsProps) => {
  const { type } = props;

  const dispatch = useAppDispatch();
  const terms = useAppSelector(termsSelector);
  const loadingTerms = useAppSelector(loadingTermsSelector);

  const document = terms?.[type];

  useEffect(() => {
    dispatch(loadTerms());
  }, []);

  return (
    <>
      {loadingTerms || !document ? (
        <Loading />
      ) : (
        document.content.components.map((docComponent, idx) => <DocComponent key={idx} component={docComponent} />)
      )}
    </>
  );
};

export default Terms;
